'use client';

import { cn } from '@/libs';

type SeparatorProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
};

export const Separator = ({ className, ...props }: SeparatorProps) => {
  return <div className={cn('h-[1px] w-full bg-foreground/10', className)} {...props} />;
};
